import React, { useEffect, useState, useContext } from "react";
import { db, auth, storage } from "../config/firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
  getDocs,
  getDoc,
  onSnapshot,
  snapshotEqual,
} from "firebase/firestore";
import { ref, uploadBytes, listAll, getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";
import { UserContext } from "../userFile";

const Post = () => {
  const [posts, setPosts] = useState([]);
  const [postContent, setPostContent] = useState("");
  const [comments, setComments] = useState([]);
  const [commentContents, setCommentContents] = useState({});

  // File upload fuctionality
  const [fileUpload, setFileUpload] = useState(null);
  const [fileList, setFileList] = useState([]);

  const postsCollectionRef = collection(db, "posts");
  const commentsCollectionRef = collection(db, "comments");

const getPosts = () => {
  onSnapshot(postsCollectionRef, (snapshot) => {
    const postsData = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setPosts(postsData);
  });
};

  const onPost = async () => {
    try {
      await addDoc(postsCollectionRef, {
        content: postContent,
        userId: auth?.currentUser?.uid,
        likes: 0,
        loves: 0,
        laughs: 0,
      });
      setPostContent("");
      getPosts();
    } catch (error) {
      console.error("Error adding post:", error);
    }
  };

const getComments = () => {
  onSnapshot(commentsCollectionRef, (snapshot) => {
    const commentsData = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    setComments(commentsData);
  });
};

  useEffect(() => {
    getPosts();
    getComments();
  }, []);

  const onComment = async (postId) => {
    try {
      const commentContent = commentContents[postId];
      if (commentContent && commentContent.trim() !== "") {
        await addDoc(commentsCollectionRef, {
          content: commentContent,
          userId: auth?.currentUser?.uid,
          postId: postId,
        });
        setCommentContents({ ...commentContents, [postId]: "" });
        getComments();
      }
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  const deleteComment = async (id) => {
    try {
      const commentDoc = doc(db, "comments", id);
      await deleteDoc(commentDoc);
      getComments();
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const deletePost = async (id) => {
    try {
      const postDoc = doc(db, "posts", id);
      await deleteDoc(postDoc);
      getPosts();
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };


const handleInteraction = async (postId, interactionType) => {
  try {
    const postRef = doc(db, "posts", postId);
    const postSnapshot = await getDoc(postRef);
    const postData = postSnapshot.data();

    // Check if the user has already interacted with the post
    if (postData[interactionType] === 1) {
      console.log("User has already interacted with this post.");
      return;
    }

    // Update the interaction
    await updateDoc(postRef, { [interactionType]: 1 });

    // Remove other interactions (like, love, laugh) if they exist
    const otherInteractions = ["likes", "loves", "laughs"].filter(
      (type) => type !== interactionType
    );
    otherInteractions.forEach(async (type) => {
      if (postData[type] === 1) {
        await updateDoc(postRef, { [type]: 0 });
      }
    });

    // Refresh the posts after updating interactions
    getPosts();
  } catch (error) {
    console.error("Error updating interaction:", error);
  }
};

  const handleCommentContentChange = (postId, content) => {
    setCommentContents({ ...commentContents, [postId]: content });
  };

  const uploadedFilesRef = ref(storage, "usersVideos");

  const uploadFile = async () => {
    if (!fileUpload) return;
    const filesFolderRef = ref(
      storage,
      `usersVideos/${fileUpload.name + v4()}`
    );
    uploadBytes(filesFolderRef, fileUpload).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setFileList((prev) => [prev, url]);
      });
    });
  };

  useEffect(() => {
    listAll(uploadedFilesRef).then((response) => {
      response.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          setFileList((prev) => [...prev, url]);
        });
      });
      console.log(response);
    });
  }, []);

  const currentUser = useContext(UserContext);

  return (
    <>
      <div className="story  col-12 mx-auto">
        <div
          className="item story-input-container m-3"
          style={{ width: "200px" }}
        >
          <input
            id="story-input"
            className="story-input btn btn-outline-success"
            type="file"
            onChange={(e) => setFileUpload(e.target.files[0])}
          />
          <button
            className="story-btn btn btn-outline-success"
            onClick={uploadFile}
          >
            upload
          </button>
        </div>
        <div className="item mx-3 d-flex  story-video-container">
          {fileList.map((url) => {
            return (
              <div>
                <video
                  src={url}
                  class="object-fit-cover col-sm-12 col-12 mx-2 rounded"
                  preload="auto"
                  autobuffer
                  width="166"
                  height="240"
                  controls
                  style={{ width: "200px" }}
                >
                  <source src={url} type="video/mp4" />
                  <source src="movie.ogg" type="video/ogg" />
                  Your browser does not support the video tag.
                </video>
              </div>
            );
          })}
        </div>
      </div>
      <div className="post-container shadow-sm p-3 mb-1 bg-body rounded col-xsm-12 col-sm-6 col-md-4 col-lg-4 col-xlg-2 border mx-auto">
        <div className="post-input ">
          <input
            type="text"
            className="col-10 border"
            value={postContent}
            onChange={(e) => setPostContent(e.target.value)}
          />
          <button type="submit" className="btn btn-success" onClick={onPost}>
            <i className="fas fa-add"></i>
          </button>
        </div>
      </div>
      {posts.map((post) => (
        <div
          className="post-output shadow p-3 mb-2 bg-body rounded col-xsm-12 col-sm-6 col-md-4 col-lg-4 col-xlg-2 p-2 border mx-auto"
          key={post.id}
        >
          <div className="post-control d-flex align-items-center justify-content-between mb-2">
            <div className="post-user-info">
              <img
                src={currentUser.photoURL}
                alt="profile photo"
                className="user-photo"
              />
              <p>{currentUser.displayName}</p>
            </div>

            <i className="fas fa-trash" onClick={() => deletePost(post.id)}></i>
          </div>
          <p className="post-text p-1">{post.content}</p>
          <div className="interactions ">
            <i
              className="like fas fa-thumbs-up"
              onClick={() => handleInteraction(post.id, "likes")}
            ></i>
            <span>{post.likes}</span>
            <i
              className="love fas fa-heart"
              onClick={() => handleInteraction(post.id, "loves")}
            ></i>
            <span>{post.loves}</span>
            <i
              className="laugh fas fa-laugh"
              onClick={() => handleInteraction(post.id, "laughs")}
            ></i>
            <span>{post.laughs}</span>
            <i className="comment fas fa-comment"></i>
            {comments.filter((comment) => comment.postId === post.id).length}
            <span></span>
          </div>
          <div className="comment-container">
            <input
              type="text"
              value={commentContents[post.id] || ""}
              onChange={(e) =>
                handleCommentContentChange(post.id, e.target.value)
              }
            />
            <button
              className="btn btn-success add-comment"
              onClick={() => onComment(post.id)}
            >
              <i class="fa-solid fa-paper-plane"></i>
            </button>
          </div>
          <div>
            {comments
              .filter((comment) => comment.postId === post.id)
              .map((comment) => (
                <div
                  className="comment-output d-flex align-items-center justify-content-between p-1 m-1"
                  key={comment.id}
                >
                  <p className="d-flex align-items-center p-2">
                    {comment.content}
                  </p>
                  <i
                    className="fas fa-trash"
                    onClick={() => deleteComment(comment.id)}
                  ></i>
                </div>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default Post;
